import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type { ReactElement } from 'react'

interface Props {
  shortErrorMessage?: string
  children?: (data: string[]) => ReactElement
}

const GetAiFeaturesRequest = ({
  shortErrorMessage,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/features`

  const { requestParams } = useGetParamsWithSpaceId({})

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetAiFeaturesRequest
